import { Injectable, inject } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { filter } from 'rxjs';
import { LoadingService } from 'svnxii-ng-shared/services';

@Injectable({
  providedIn: 'root',
})
export class RouteLoadingService {
  private router = inject(Router);
  private loadingService = inject(LoadingService);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.loadingService.show('route');
        } else {
          this.loadingService.hide('route');
        }
      });
  }
}
